export const classes = {
  card: 'relative flex bg-white dark:bg-[#332e43] border border-grey-4 dark:border-white/10 p-0 size-[225px] shadow-none overflow-hidden',
  auroraCard:
    'relative flex aspect-square w-full overflow-hidden rounded-[14px] border border-solid border-black/10 bg-white/[0.82] p-0 shadow-aurora-card transition-[box-shadow,border-color] hover:border-[#4a72d0]/50 hover:shadow-file-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  auroraPreviewOverlay:
    'preview-overlay absolute inset-0 z-10 opacity-0 transition-opacity pointer-events-none bg-[linear-gradient(180deg,rgba(28,36,66,0.82),rgba(38,52,96,0.34)_42%,rgba(34,56,106,0.34)_58%,rgba(30,52,104,0.82))]',
  compactCard:
    'flex flex-row items-center gap-3 bg-white dark:bg-[#332e43] border border-grey-4 dark:border-white/10 px-3 py-2 w-[225px] shadow-none',
  auroraCompactCard:
    'flex flex-row items-center gap-[11px] rounded-[14px] border border-solid border-black/10 bg-white/[0.82] px-[13px] py-[11px] shadow-aurora-card transition-[box-shadow,border-color] hover:border-brand-accent/[0.28] hover:shadow-row-hover dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  compactBody: 'flex-1 min-w-0 flex flex-col gap-0.5 cursor-pointer',
  compactName:
    'text-sm font-medium text-grey-7 dark:text-mauve-2 hover:underline cursor-pointer text-nowrap',
  auroraCompactName:
    'text-[13px] font-semibold text-taupe-3 hover:underline cursor-pointer text-nowrap dark:text-mauve-1',
  compactOptions: 'shrink-0',
  compactCount: 'text-sm text-grey-6 dark:text-mauve-3 text-light',
  auroraCompactCount: 'text-[11px] text-taupe-1 dark:text-mauve-3',
  previewWrapper: 'absolute inset-0 place-center cursor-pointer',
  previewOverlay:
    'preview-overlay absolute inset-0 z-10 bg-black/50 opacity-0 transition-opacity pointer-events-none',
  topScrim:
    'absolute inset-x-0 top-0 z-20 flex items-start justify-between gap-2 p-3 pointer-events-none',
  topScrimPreview: 'preview-meta opacity-0 transition-opacity',
  title: 'flex flex-col gap-1 min-w-0',
  name: 'text-sm font-medium text-grey-7 dark:text-mauve-2 hover:underline cursor-pointer text-nowrap pointer-events-auto',
  namePreview: 'text-white drop-shadow',
  pill: 'self-start',
  auroraPill:
    'rounded-full border-0 px-[11px] py-[4px] text-[11px] font-semibold tracking-[0.03em]',
  overlayPill: 'border-0 bg-white/[0.24] text-white',
  optionsWrapper: 'pointer-events-auto',
  optionsIcon: 'options-icon cursor-pointer transition-opacity opacity-0',
  optionsIconPreview: 'drop-shadow',
  bottomScrim:
    'meta-overlay absolute inset-x-0 bottom-0 z-20 flex justify-between gap-2 px-3 pb-2 text-xs text-grey-6 dark:text-mauve-3 opacity-0 transition-opacity pointer-events-none',
  bottomScrimPreview: 'text-white/90',
  // Marker class: keeps the hover-reveal active while the options menu is open
  menuOpen: 'menu-open',
};

export const styles = {
  card: {
    '&:hover .options-icon, &.menu-open .options-icon': { opacity: 1 },
    '&:hover .meta-overlay, &.menu-open .meta-overlay': { opacity: 1 },
    '&:hover .preview-overlay, &.menu-open .preview-overlay': { opacity: 1 },
    '&:hover .preview-meta, &.menu-open .preview-meta': { opacity: 1 },
  },
};
